export const environment = {
  maintenanceDashboardGraphql: false,
  production: false,
  apiGatewayUrl: 'https://api-dev.apex-habitat.com/dev',
  publicAppUrl: 'https://dev.apex-habitat.com',
  backofficeAppUrl: 'https://backoffice-dev.apex-habitat.com',
  tenantAppUrl: 'https://tenant-dev.apex-habitat.com',
  platformAdminAppUrl: 'https://admin-dev.apex-habitat.com',
  maintenanceAppUrl: 'https://maintenance-dev.apex-habitat.com',
};
